export function SET_FILTER_DATA(payload) {
	return {
		type: 'SET_FILTER_DATA',
		payload: payload,
	};
}
